// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { CheckDTO } from '../models';
import { CreateReferenceDTO } from '../models';
import { ReferenceDTO } from '../models';
import { ReferenceDocumentDTO } from '../models';
import { SearchReferencesResultsDTO } from '../models';
/**
 * ReferencesApi - axios parameter creator
 * @export
 */
export const ReferencesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a Reference
         * @param {CreateReferenceDTO} createReferenceDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReference(createReferenceDTO: CreateReferenceDTO, options: any = {}): RequestArgs {
            // verify required parameter 'createReferenceDTO' is not null or undefined
            if (createReferenceDTO === null || createReferenceDTO === undefined) {
                throw new RequiredError('createReferenceDTO','Required parameter createReferenceDTO was null or undefined when calling createReference.');
            }
            const localVarPath = `/v2/references`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"CreateReferenceDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(createReferenceDTO !== undefined ? createReferenceDTO : {}) : (createReferenceDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Reference By Id
         * @param {string} id Reference id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findReferenceById(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling findReferenceById.');
            }
            const localVarPath = `/v2/references/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Checks for a Reference By Id
         * @param {string} id Reference id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChecks(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getChecks.');
            }
            const localVarPath = `/v2/references/{id}/checks`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Documents for a Reference By Id
         * @param {string} id Reference id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferenceDocuments(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getReferenceDocuments.');
            }
            const localVarPath = `/v2/references/{id}/documents`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Set a Reference as ready for review
         * @param {string} id Reference id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readyForReview(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling readyForReview.');
            }
            const localVarPath = `/v2/references/{id}/review`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Search for references by status
         * @param {string} status Reference status
         * @param {number} page Page to start on (defaults to 1)
         * @param {number} size Size of result set to return (defaults to 15)
         * @param {'CREATED_AT'} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchReferences(status: string, page: number, size: number, sortBy?: 'CREATED_AT', options: any = {}): RequestArgs {
            // verify required parameter 'status' is not null or undefined
            if (status === null || status === undefined) {
                throw new RequiredError('status','Required parameter status was null or undefined when calling searchReferences.');
            }
            // verify required parameter 'page' is not null or undefined
            if (page === null || page === undefined) {
                throw new RequiredError('page','Required parameter page was null or undefined when calling searchReferences.');
            }
            // verify required parameter 'size' is not null or undefined
            if (size === null || size === undefined) {
                throw new RequiredError('size','Required parameter size was null or undefined when calling searchReferences.');
            }
            const localVarPath = `/v2/references/search`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Submit all Empty checks for a Reference
         * @param {string} id Reference id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitChecks(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling submitChecks.');
            }
            const localVarPath = `/v2/references/{id}/checks/submit`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReferencesApi - functional programming interface
 * @export
 */
export const ReferencesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Create a Reference
         * @param {CreateReferenceDTO} createReferenceDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReference(createReferenceDTO: CreateReferenceDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferenceDTO> {
            const localVarAxiosArgs = ReferencesApiAxiosParamCreator(configuration).createReference(createReferenceDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get Reference By Id
         * @param {string} id Reference id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findReferenceById(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferenceDTO> {
            const localVarAxiosArgs = ReferencesApiAxiosParamCreator(configuration).findReferenceById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get Checks for a Reference By Id
         * @param {string} id Reference id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChecks(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CheckDTO>> {
            const localVarAxiosArgs = ReferencesApiAxiosParamCreator(configuration).getChecks(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get Documents for a Reference By Id
         * @param {string} id Reference id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferenceDocuments(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReferenceDocumentDTO>> {
            const localVarAxiosArgs = ReferencesApiAxiosParamCreator(configuration).getReferenceDocuments(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Set a Reference as ready for review
         * @param {string} id Reference id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readyForReview(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferenceDTO> {
            const localVarAxiosArgs = ReferencesApiAxiosParamCreator(configuration).readyForReview(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Search for references by status
         * @param {string} status Reference status
         * @param {number} page Page to start on (defaults to 1)
         * @param {number} size Size of result set to return (defaults to 15)
         * @param {'CREATED_AT'} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchReferences(status: string, page: number, size: number, sortBy?: 'CREATED_AT', options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchReferencesResultsDTO> {
            const localVarAxiosArgs = ReferencesApiAxiosParamCreator(configuration).searchReferences(status, page, size, sortBy, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Submit all Empty checks for a Reference
         * @param {string} id Reference id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitChecks(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CheckDTO>> {
            const localVarAxiosArgs = ReferencesApiAxiosParamCreator(configuration).submitChecks(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ReferencesApi - factory interface
 * @export
 */
export const ReferencesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Create a Reference
         * @param {CreateReferenceDTO} createReferenceDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReference(createReferenceDTO: CreateReferenceDTO, options?: any) {
            return ReferencesApiFp(configuration).createReference(createReferenceDTO, options)(axios, basePath);
        },
        /**
         * Get Reference By Id
         * @param {string} id Reference id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findReferenceById(id: string, options?: any) {
            return ReferencesApiFp(configuration).findReferenceById(id, options)(axios, basePath);
        },
        /**
         * Get Checks for a Reference By Id
         * @param {string} id Reference id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChecks(id: string, options?: any) {
            return ReferencesApiFp(configuration).getChecks(id, options)(axios, basePath);
        },
        /**
         * Get Documents for a Reference By Id
         * @param {string} id Reference id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferenceDocuments(id: string, options?: any) {
            return ReferencesApiFp(configuration).getReferenceDocuments(id, options)(axios, basePath);
        },
        /**
         * Set a Reference as ready for review
         * @param {string} id Reference id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readyForReview(id: string, options?: any) {
            return ReferencesApiFp(configuration).readyForReview(id, options)(axios, basePath);
        },
        /**
         * Search for references by status
         * @param {string} status Reference status
         * @param {number} page Page to start on (defaults to 1)
         * @param {number} size Size of result set to return (defaults to 15)
         * @param {'CREATED_AT'} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchReferences(status: string, page: number, size: number, sortBy?: 'CREATED_AT', options?: any) {
            return ReferencesApiFp(configuration).searchReferences(status, page, size, sortBy, options)(axios, basePath);
        },
        /**
         * Submit all Empty checks for a Reference
         * @param {string} id Reference id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitChecks(id: string, options?: any) {
            return ReferencesApiFp(configuration).submitChecks(id, options)(axios, basePath);
        },
    };
};

/**
 * ReferencesApi - interface
 * @export
 * @interface ReferencesApi
 */
export interface ReferencesApiInterface {
    /**
     * Create a Reference
     * @param {CreateReferenceDTO} createReferenceDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferencesApiInterface
     */
    createReference(createReferenceDTO: CreateReferenceDTO, options?: any): AxiosPromise<ReferenceDTO>;

    /**
     * Get Reference By Id
     * @param {string} id Reference id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferencesApiInterface
     */
    findReferenceById(id: string, options?: any): AxiosPromise<ReferenceDTO>;

    /**
     * Get Checks for a Reference By Id
     * @param {string} id Reference id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferencesApiInterface
     */
    getChecks(id: string, options?: any): AxiosPromise<Array<CheckDTO>>;

    /**
     * Get Documents for a Reference By Id
     * @param {string} id Reference id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferencesApiInterface
     */
    getReferenceDocuments(id: string, options?: any): AxiosPromise<Array<ReferenceDocumentDTO>>;

    /**
     * Set a Reference as ready for review
     * @param {string} id Reference id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferencesApiInterface
     */
    readyForReview(id: string, options?: any): AxiosPromise<ReferenceDTO>;

    /**
     * Search for references by status
     * @param {string} status Reference status
     * @param {number} page Page to start on (defaults to 1)
     * @param {number} size Size of result set to return (defaults to 15)
     * @param {'CREATED_AT'} [sortBy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferencesApiInterface
     */
    searchReferences(status: string, page: number, size: number, sortBy?: 'CREATED_AT', options?: any): AxiosPromise<SearchReferencesResultsDTO>;

    /**
     * Submit all Empty checks for a Reference
     * @param {string} id Reference id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferencesApiInterface
     */
    submitChecks(id: string, options?: any): AxiosPromise<Array<CheckDTO>>;

}

/**
 * ReferencesApi - object-oriented interface
 * @export
 * @class ReferencesApi
 * @extends {BaseAPI}
 */
export class ReferencesApi extends BaseAPI implements ReferencesApiInterface {
    /**
     * Create a Reference
     * @param {CreateReferenceDTO} createReferenceDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferencesApi
     */
    public createReference(createReferenceDTO: CreateReferenceDTO, options?: any) {
        return ReferencesApiFp(this.configuration).createReference(createReferenceDTO, options)(this.axios, this.basePath);
    }

    /**
     * Get Reference By Id
     * @param {string} id Reference id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferencesApi
     */
    public findReferenceById(id: string, options?: any) {
        return ReferencesApiFp(this.configuration).findReferenceById(id, options)(this.axios, this.basePath);
    }

    /**
     * Get Checks for a Reference By Id
     * @param {string} id Reference id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferencesApi
     */
    public getChecks(id: string, options?: any) {
        return ReferencesApiFp(this.configuration).getChecks(id, options)(this.axios, this.basePath);
    }

    /**
     * Get Documents for a Reference By Id
     * @param {string} id Reference id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferencesApi
     */
    public getReferenceDocuments(id: string, options?: any) {
        return ReferencesApiFp(this.configuration).getReferenceDocuments(id, options)(this.axios, this.basePath);
    }

    /**
     * Set a Reference as ready for review
     * @param {string} id Reference id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferencesApi
     */
    public readyForReview(id: string, options?: any) {
        return ReferencesApiFp(this.configuration).readyForReview(id, options)(this.axios, this.basePath);
    }

    /**
     * Search for references by status
     * @param {string} status Reference status
     * @param {number} page Page to start on (defaults to 1)
     * @param {number} size Size of result set to return (defaults to 15)
     * @param {'CREATED_AT'} [sortBy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferencesApi
     */
    public searchReferences(status: string, page: number, size: number, sortBy?: 'CREATED_AT', options?: any) {
        return ReferencesApiFp(this.configuration).searchReferences(status, page, size, sortBy, options)(this.axios, this.basePath);
    }

    /**
     * Submit all Empty checks for a Reference
     * @param {string} id Reference id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferencesApi
     */
    public submitChecks(id: string, options?: any) {
        return ReferencesApiFp(this.configuration).submitChecks(id, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for ReferencesApi
 * Import individual functions for optimal bundle size
 */
/**
 * Create a Reference
 * @param {CreateReferenceDTO} createReferenceDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function createReference(
    createReferenceDTO: CreateReferenceDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ReferenceDTO> {
    const localVarAxiosArgs = ReferencesApiAxiosParamCreator(configuration).createReference(createReferenceDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get Reference By Id
 * @param {string} id Reference id 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function findReferenceById(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ReferenceDTO> {
    const localVarAxiosArgs = ReferencesApiAxiosParamCreator(configuration).findReferenceById(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get Checks for a Reference By Id
 * @param {string} id Reference id 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getChecks(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<Array<CheckDTO>> {
    const localVarAxiosArgs = ReferencesApiAxiosParamCreator(configuration).getChecks(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get Documents for a Reference By Id
 * @param {string} id Reference id 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getReferenceDocuments(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<Array<ReferenceDocumentDTO>> {
    const localVarAxiosArgs = ReferencesApiAxiosParamCreator(configuration).getReferenceDocuments(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Set a Reference as ready for review
 * @param {string} id Reference id 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function readyForReview(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<ReferenceDTO> {
    const localVarAxiosArgs = ReferencesApiAxiosParamCreator(configuration).readyForReview(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Search for references by status
 * @param {string} status Reference status
 * @param {number} page Page to start on (defaults to 1)
 * @param {number} size Size of result set to return (defaults to 15)
 * @param {'CREATED_AT'} [sortBy] 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function searchReferences(
    status: string,
    page: number,
    size: number,
    sortBy?: 'CREATED_AT',
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<SearchReferencesResultsDTO> {
    const localVarAxiosArgs = ReferencesApiAxiosParamCreator(configuration).searchReferences(status, page, size, sortBy, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Submit all Empty checks for a Reference
 * @param {string} id Reference id 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function submitChecks(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<Array<CheckDTO>> {
    const localVarAxiosArgs = ReferencesApiAxiosParamCreator(configuration).submitChecks(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

